import { useQuery } from '@tanstack/react-query'
import { api, query } from '../../api/client'
import type { AppSummary } from '../../api/types'
import { PLATFORM_LABELS } from '../../hooks/useMeta'
import { AppCell } from '../AppCell'

type Result = AppSummary & { platforms: string[] }

/** Apps AppOutlet has seen in a tracked chart, searched as you type. */
export function LocalResults({ term }: { term: string }) {
	const results = useQuery({
		queryKey: ['search', term],
		queryFn: () => api.get<Result[]>(`/api/v1/apps/search${query({ q: term, limit: 50 })}`),
		enabled: term.length > 0,
	})
	if (!term) return <div className="empty">Search every app that has appeared in a tracked chart.</div>
	if (results.isPending) return <div className="page-loading">Searching…</div>
	if (!results.data?.length) return <div className="empty">No apps match “{term}”.</div>
	return (
		<table>
			<tbody>
				{results.data.map((app) => (
					<tr key={app.id}>
						<td style={{ maxWidth: 0, width: '100%' }}>
							<AppCell app={app} />
						</td>
						<td className="muted small" style={{ whiteSpace: 'nowrap' }}>
							{app.platforms.map((p) => PLATFORM_LABELS[p] ?? p).join(', ')}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
